export interface DeleteConfig<T> {
  allowDeleting?: boolean;
  confirmationTitle?: string;
  confirmationMessage?: string;
  selectionConfirmationTitle?: string;
  selectionConfirmationMessage?: string;
  isExternalDelete?: boolean;
  onDeleted?: (...rows: T[]) => void;
}
